/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DisabledIntegration } from './DisabledIntegration';
import {
    DisabledIntegrationFromJSON,
    DisabledIntegrationFromJSONTyped,
    DisabledIntegrationToJSON,
} from './DisabledIntegration';

/**
 * 
 * @export
 * @interface DisabledIntegrationsResponse
 */
export interface DisabledIntegrationsResponse {
    /**
     * 
     * @type {Array<DisabledIntegration>}
     * @memberof DisabledIntegrationsResponse
     */
    disabled_integrations: Array<DisabledIntegration>;
}

/**
 * Check if a given object implements the DisabledIntegrationsResponse interface.
 */
export function instanceOfDisabledIntegrationsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "disabled_integrations" in value;

    return isInstance;
}

export function DisabledIntegrationsResponseFromJSON(json: any): DisabledIntegrationsResponse {
    return DisabledIntegrationsResponseFromJSONTyped(json, false);
}

export function DisabledIntegrationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisabledIntegrationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disabled_integrations': ((json['disabled_integrations'] as Array<any>).map(DisabledIntegrationFromJSON)),
    };
}

export function DisabledIntegrationsResponseToJSON(value?: DisabledIntegrationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disabled_integrations': ((value.disabled_integrations as Array<any>).map(DisabledIntegrationToJSON)),
    };
}

